export default (intl) => ({
	ALL: intl.formatMessage({ id: 'app.results.completeness-all' }),
	COMPLETE: intl.formatMessage({ id: 'app.results.completeness-complete' }),
	DISCARDED: intl.formatMessage({ id: 'app.results.completeness-discarded' }),
});
